import { useCallback, useLayoutEffect, useRef, useState, lazy, Suspense } from 'react';
import { MdAttachFile, MdEmojiEmotions, MdSend } from 'react-icons/md';
import ComandiQui, { useComandiQui } from './ComandiQui';
const EmojiPicker = lazy(() => import('emoji-picker-react'));
// Con mouse e tastiera Invio invia; Maiusc+Invio e Ctrl+Invio vanno a capo.
// Sul telefono Invio va a capo e si invia col pulsante, come in WhatsApp.
export const tastieraFisica = () => typeof window !== 'undefined' && !!window.matchMedia?.('(pointer: fine)')?.matches;

export function tastoInvio(e, { messageText, setMessageText, handleSend }) {
  if (e.key !== 'Enter' || e.nativeEvent?.isComposing || !tastieraFisica() || e.shiftKey) return;
  e.preventDefault();
  if (e.ctrlKey || e.metaKey) {
    const campo = e.target;
    const inizio = campo.selectionStart ?? messageText.length;
    const fine = campo.selectionEnd ?? inizio;
    setMessageText(messageText.slice(0, inizio) + '\n' + messageText.slice(fine));
    requestAnimationFrame(() => { campo.selectionStart = campo.selectionEnd = inizio + 1; });
    return;
  }
  handleSend();
}

// Fino a sette righe, poi il testo scorre dentro il campo, come su WhatsApp.
const ALTEZZA_MASSIMA = 178;
export default function ChatComposer({ fileInputRef, setSelectedFile, activeSession, sending, emojiRef, showEmoji, setShowEmoji, handleEmojiClick, messageText, setMessageText, handleSend, replyTo, selectedFile, contactId }) {
  const input = useRef(null);
  useLayoutEffect(() => { if (input.current) { input.current.style.height = 'auto'; input.current.style.height = `${Math.min(input.current.scrollHeight, ALTEZZA_MASSIMA)}px`; } }, [messageText]);
  // I comandi attivi in questa chat: il bottone «@» c'è solo se ce n'è almeno uno (04/10/2026).
  const comandi = useComandiQui(contactId);
  const conComandi = !!comandi && (comandi.comandi.length > 0 || comandi.info.length > 0);
  const [comandiAperti, setComandiAperti] = useState(false);
  const chiudiComandi = useCallback(() => setComandiAperti(false), []);
  const scegliComando = testo => {
    setMessageText(testo); setComandiAperti(false);
    requestAnimationFrame(() => { const c = input.current; if (c) { c.focus(); c.selectionStart = c.selectionEnd = testo.length; } });
  };
  const scrivi = testo => {
    setMessageText(testo);
    // Una «@» come primo carattere apre l'elenco, come le menzioni di WhatsApp.
    if (conComandi && testo === '@' && !messageText) setComandiAperti(true);
  };
  return <div className="mobile-composer">
    {comandiAperti && conComandi && <ComandiQui dati={comandi} onScegli={scegliComando} onChiudi={chiudiComandi} />}
    <input aria-label="Scegli allegato" type="file" ref={fileInputRef} onChange={e => { if (e.target.files?.[0]) setSelectedFile(e.target.files[0]); e.target.value = ''; }} className="hidden" accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx" />
    <button className="icon-button attach-button" aria-label="Allega file" disabled={!activeSession || sending} onClick={() => fileInputRef.current?.click()}><MdAttachFile size={25} /></button>
    {conComandi && <button type="button" className="icon-button comandi-button" aria-label="Comandi in questa chat" aria-expanded={comandiAperti}
      disabled={!activeSession || sending} onClick={() => setComandiAperti(!comandiAperti)}>@</button>}
    <div className="composer-field"><textarea ref={input} rows={1} aria-label="Messaggio" disabled={!activeSession || sending} value={messageText} onChange={e => scrivi(e.target.value)}
      onKeyDown={e => tastoInvio(e, { messageText, setMessageText, handleSend })}
      placeholder={replyTo ? 'La tua risposta…' : selectedFile ? 'Aggiungi una didascalia…' : tastieraFisica() ? 'Scrivi un messaggio · Invio per inviare' : 'Scrivi un messaggio…'} />
      <div ref={emojiRef}><button className="icon-button emoji-button" aria-label="Emoji" aria-expanded={showEmoji} disabled={sending} onClick={() => setShowEmoji(!showEmoji)}><MdEmojiEmotions size={23} /></button>{showEmoji && <div className="mobile-emoji"><Suspense fallback={<p>Caricamento emoji…</p>}><EmojiPicker onEmojiClick={handleEmojiClick} width="100%" height={320} searchPlaceholder="Cerca emoji…" previewConfig={{ showPreview: false }} /></Suspense></div>}</div>
    </div>
    <button className="send-button" onClick={handleSend} aria-label="Invia messaggio" disabled={sending || !activeSession || (!messageText.trim() && !selectedFile)}><MdSend size={22} /></button>
  </div>;
}

